module.exports = __webpack_public_path__ + "img/dev-developers.0f95d80c.png";